// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { post } from '../../../../common/api'
import { GET_ANNUAL_LEAVE } from '../../../../common/constant'

export const actionGetAnnuaLeave = createAsyncThunk('appGetAnnuaLeave/actionGetDepartment', async (params, thunkAPI) => {
    return await post(GET_ANNUAL_LEAVE, params, thunkAPI)
})

export const appLeaveSettingSlice = createSlice({
    name: 'appLeaveSetting',
    initialState: {

        //get
        loadingGet: false,
        getAnnualLeave: null

    },
    reducers: {
        //reset or delete Add Insurance Company store data
        resetGetAnnualLeaveResponse: (state) => {
            state.getAnnualLeave = null
        }
    },
    extraReducers: builder => {
        builder
            //get
            .addCase(actionGetAnnuaLeave.pending, (state) => {
                state.loadingGet = true
            })
            .addCase(actionGetAnnuaLeave.fulfilled, (state, action) => {
                state.loadingGet = false
                state.getAnnualLeave = action.payload
            })
            .addCase(actionGetAnnuaLeave.rejected, (state) => {
                state.loadingGet = false
            })
    }
})
export const { resetGetAnnualLeaveResponse } = appLeaveSettingSlice.actions

export default appLeaveSettingSlice.reducer